import React from 'react';
import { toast } from 'react-toastify';

import _ from 'lodash'
import 'react-toastify/dist/ReactToastify.css';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

const Content = (props) => {
    let {showTitleIcon, titleIcon, title, message} = props;
    return (
        <>
        <div className="mb-1">
            <div className="d-table-row">
                {showTitleIcon && <div className="d-table-cell align-middle pt-1"><CsLineIcons icon={titleIcon} width="30" height="30" size="40" className="cs-icon icon  me-3 align-middle" /></div>}
                <div className="d-table-cell align-middle font-heading">{title}</div>
            </div>
        </div>
        {message!=="" && <div className="mt-2 mb-2" dangerouslySetInnerHTML={{__html: message}} />}
        </>
    );
};

export const showToast = (config) => {
    const type = (_.has(config,"type"))?config.type.toLowerCase():'info';
    const showTitleIcon = (_.has(config,"showTitleIcon"))?config.showTitleIcon:true; 
    const title = (_.has(config,"title"))?config.title:'Notification';    
    const message = (_.has(config,"message"))?config.message:'';
    const hideProgressBar = (_.has(config,"hideProgressBar"))?config.hideProgressBar:'false';
    let autoClose = 8000;
    if(_.has(config,"autoClose") && (_.isNumber(config.autoClose) || config.autoClose===false)){autoClose = config.autoClose};
    const draggable = false;
    
    let typeClass = 'info';
    let defaultTitleIcon = 'info';
    switch(type) {
        case 'success':
            typeClass = 'success';
            defaultTitleIcon = 'like';
            break;
        case 'error':
            typeClass = 'danger';
            defaultTitleIcon = 'error-hexagon';
          break;
        case 'warning':
            typeClass = 'warning';
            defaultTitleIcon = 'warning-hexagon';
            break;
        case 'info':
            typeClass = 'info';
            defaultTitleIcon = 'notification';
            break;
        default:
            typeClass = 'info';
            defaultTitleIcon = 'notification';
    }
    const titleIcon = (_.has(config,"titleIcon"))?config.titleIcon:defaultTitleIcon;
    toast(<Content type={type} showTitleIcon={showTitleIcon} titleIcon={titleIcon} title={title} message={message} />, {position:"top-right", className: `workabl-toast workabl-toast-${typeClass}`, toastClassName:'workabl-toast-container', progressClassName: 'workabl-toast-progressbar', autoClose, draggable, hideProgressBar})    
};